var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('go-top',{attrs:{"size":50,"alt":"backtotop","has-outline":false}}),_c('Header'),_c('Menu'),_vm._t("default"),_c('Footer')],2)}
var staticRenderFns = []

export { render, staticRenderFns }